import React from 'react';
import {Image} from 'react-bootstrap';

class Publicity extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onImgLoad = this.onImgLoad.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      index: 0,
      direction: null,
      dimensions: {},
    };
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  onImgLoad({target:img}, index) {
    this.setState({dimensions:{height:img.offsetHeight, width:img.offsetWidth}});
    //console.log('y: ', img.offsetHeight, 'x: ', img.offsetWidth, 'index: ', index)
  }
 
  render() {
    var background;
    if (this.props.ancoragem === 'width')
      background = {width: '100vw'}; 
    else 
      background = {height: '100vh'}; //{width: '100vw', heigth: '100vh'}; 
    
    //var img = "./publicidade/background"+document.location.href.split('/')[3]+".jpg";
	  var img = this.props.envObj.background
  
    return (
        <Image 
          style={background}  
          src={img}
          onClick={() => window.location.href = "http://www.valenet.tv.br/quizvalenet/"}>   
        </Image>
    );
  }
}

//"http://www3.valenet.com.br/"

export default Publicity;
